import { useAnalyticsFilters } from "providers/AnalyticsProvider/AnalyticsFilterProvider";

type TableType = "domain" | "error";

/**
 * Hook for managing customised column visibility.
 *
 * localStorage hydration + persistence is handled inside
 * AnalyticsFilterProvider so tables reflect the user's saved preferences on
 * first paint. This hook is now a thin selector over the provider state.
 */
export const useCustomizeColumns = (tableType: TableType) => {
  const {
    selectedDomainColumns,
    setSelectedDomainColumns,
    selectedErrorColumns,
    setSelectedErrorColumns,
  } = useAnalyticsFilters();

  const selectedColumns = tableType === "domain" ? selectedDomainColumns : selectedErrorColumns;
  const setSelectedColumns =
    tableType === "domain" ? setSelectedDomainColumns : setSelectedErrorColumns;

  return {
    selectedColumns,
    setSelectedColumns,
  };
};
